<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>账号管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>账号列表</h2>
                <div class="item" @click="add"><i class="icon el-icon-circle-plus" type="primary"></i>新建管理员</div>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-form :inline="true" class="demo-form-inline" size="mini">
                    <el-form-item label="城市名称" v-if="role_id==1">
                        <el-select v-model="city_name" filterable placeholder="输入城市关键字" clearable @clear="getAccount()">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="账号">
                        <el-input v-model="username" placeholder="请输入账号" clearable @clear="getAccount()"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="mobile" placeholder="请输入手机号" clearable @clear="getAccount()"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getAccount">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="accountList"
                        border
                        size="mini"
                        v-loading="loading"
                        style="width: 100%">

                    <el-table-column
                            prop="username"
                            label="账号"
                            align="center"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="mobile"
                            label="手机号"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="realname"
                            label="真实名称"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="role_id"
                            label="账号类型"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.role_id==1">超级管理员</span>
                            <span v-if="scope.row.role_id==2">城市代理</span>
                            <span v-if="scope.row.role_id==3">类型代理</span>
                            <span v-if="scope.row.role_id==4">管理员</span>
                            <span v-if="scope.row.role_id==5">平台管理员</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="last_ip"
                            label="最后登录IP"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="last_city"
                            label="最后登录城市"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="last_login"
                            label="最后登录时间"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="账号状态"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.status==1">正常</span>
                            <span v-if="scope.row.status==8" style="color: #f00;">冻结</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="updateRow(scope.row)">修改</el-button>
                            <el-button type="text" v-if="scope.row.status==1" size="small" @click="blocking(scope.row,8)">冻结</el-button>
                            <el-button type="text" v-if="scope.row.status==8" size="small" @click="blocking(scope.row,1)">解冻</el-button>
                            <el-button type="text" size="small" @click="blocking(scope.row,9)">删除</el-button>
<!--                            <el-button type="text" v-if="scope.row.role_id==5" size="small" @click="setLimit(scope.row)">权限修改</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
                        :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>

        <el-dialog
                title="账号修改"
                :visible.sync="updatePop"
                width="500px"
                >
            <el-form ref="form" :rules="rules"  :model="form" label-width="80px">
                <el-form-item label="账号" prop="username">
                    <el-input v-model="form.username" auto-complete="fase"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="form.password" auto-complete="fase" type="password"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" prop="realname">
                    <el-input v-model="form.realname"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
            </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelUpdate">取 消</el-button>
                    <el-button type="primary" @click="affUpdate">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog title="新建总台管理员" :visible.sync="ztAdmin" width="400px">
            <el-form :model="form" style="width: 350px">
                <el-form-item label="账号名称" label-width="100px" style="width: 300px">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="账号密码" label-width="100px"  style="width: 300px">
                    <el-select v-model="form.region" placeholder="请选择活动区域">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button @click="ztAdmin = false">取 消</el-button>
                <el-button type="primary" @click="ztAdmin = false">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="安全验证" :visible.sync="deletePop" width="500px">
            <el-form style="width: 350px">
                <el-form-item label="安全手机验证码" label-width="120px" style="width: 400px">
                    <el-input v-model="code" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button @click="cancelDel">取 消</el-button>
                <el-button type="primary" @click="deleteAdimg">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
                title="管理员权限修改"
                :visible.sync="limitPop"
                width="600px">
            <el-tree
                    ref="upTree"
                    :data="Qxlist"
                    show-checkbox
                    node-key="id"
                    :default-checked-keys="limitData"
                    :props="defaultProps">
            </el-tree>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelLimit">取 消</el-button>
                    <el-button type="primary" @click="submitLimit">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import {getAdminList,updateAdmin,getRoleMobile,getCode} from '../../api/index'
    import {roleList, updateUserinfo,getUserinfo} from '../../api/role'
    import {searchCity} from "../../api/city";
    import {editBusiness} from "../../api/agency";
    export default {
        name: "account",
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return{
                username:'',
                mobile:'',
                city_name:'',
                accountList:[],
                page:1,
                pages:1,
                loading:false,
                updatePop:false,//更新弹窗控制
                updateData:'',//需更新的数据
                role_id:0,
                curMobile:'',//安全手机号
                deletePop:false,
                deleteId:'',
                code:'',
                form:{
                    admin_id:'',
                    role_id:'',
                    username:'',
                    password:'',
                    realname:'',
                    mobile:'',
                },
                cityList:[],
                ztAdmin:false,
                limitPop:false,
                rules:{
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    realname: [
                        { required: true, message: '请输入真实姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                },
                Limitform:'',
                limitData:[],
                Qxlist:[],
                defaultProps: {
                    children: 'child',
                    label: 'cname'
                },
            }
        },
        created(){
            this.role_id=localStorage.getItem('ROLE');
            this.getAccount();
            this.searchCity();
            this.getMobile();
        },
        methods:{
            //获取权限列表
            getQxlist(){
                roleList().then(res=>{
                    if(res.code==1){
                        this.Qxlist=res.data;
                    }
                })
            },
            getMobile(){
                getRoleMobile().then(res=>{
                    if(res.code==1){
                        this.curMobile=res.data.value;
                    }
                })
            },
            //获取账号列表
            getAccount(){
                this.loading=true;
                getAdminList({
                    p:this.page,
                    mobile:this.mobile,
                    username:this.username,
                    city_name:this.city_name
                }).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.accountList=res.data.list;
                        this.pages=res.data.total_page;
                    }
                })
            },
            searchCity(){
                searchCity({level:2}).then(res=>{
                    if(res.code==1){
                        console.log(res);
                        this.cityList=res.data;
                    }
                })
            },
            handleCurrentChange(p){
                this.page = p;
                this.getAccount()
            },
            deleteAdimg(){
                this.openFullScreen2();
                updateAdmin({
                    admin_id:this.deleteId,
                    status:9,
                    code:this.code
                }).then(res=>{
                    this.loading.close();
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.deletePop=false;
                        this.code='';
                        this.getAccount();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            cancelDel(){
                this.deleteId='';
                this.deletePop=false;
            },
            senCode(){
                let that=this;
                getCode({mobile:this.curMobile}).then(res=>{
                    if(res.code==1){
                        this.$alert(`验证码发送成功,请查看安全手机尾数为${this.curMobile.substr(-4)}的验证码`, '提示', {
                            confirmButtonText: '确定',
                            callback:action => {
                                that.deletePop=true;
                            }
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            blocking(row,s){
                if(s==9){
                    this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.deleteId=row.admin_id;
                        this.senCode();
                    })
                }else{
                    this.openFullScreen2();
                    updateAdmin({
                        admin_id:row.admin_id,
                        status:s
                    }).then(res=>{
                        this.loading.close();
                        if(res.code==1){
                            this.$message.success('操作成功');
                            this.getAccount();
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            openFullScreen2() {
               this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            cancelUpdate(){
                this.updatePop=false;
                this.form={
                        admin_id:'',
                        username:'',
                        password:'',
                        realname:'',
                        mobile:'',
                    }
            },
            updateRow(row){
                this.updatePop=true;
                this.form.admin_id=row.admin_id;
                this.form.role_id=row.role_id;
                this.form.username=row.username;
                this.form.password='aaaaaaaaaa';
                this.form.realname=row.realname;
                this.form.mobile=row.mobile;
            },
            affUpdate(){
                if(!this.form.username){
                    this.$message.error('必须输入账号');
                    return;
                }
                if(!this.form.password||this.form.password.length<6){
                    this.$message.error('必须输入密码且密码长度不能低于6位');
                    return;
                }
                if(!this.form.realname){
                    this.$message.error('必须输入真实姓名');
                    return;
                }
                if(!/^[1][0-9]{10}$/.test(this.form.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                if(this.form.password=='aaaaaaaaaa'){
                    this.form.password='';
                }
                updateUserinfo(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.form={
                            admin_id:'',
                            username:'',
                            password:'',
                            realname:'',
                            mobile:'',
                        }
                        this.getAccount();
                        this.updatePop=false;
                    }else{
                        this.$message.error(res.msg);
                    }
                })

            },
            add(){
                this.$router.push({path: '/account/add'});
            },
            setLimit(row){
                getUserinfo({admin_id:row.admin_id}).then(res=>{
                    if(res.code==1){
                        // this.Limitform=row;
                        // console.log(row);
                        // let arr=row.role_adm_access_ids.split(',');
                        // if(arr&&arr.length>0){
                        //     this.limitData=arr
                        // }else{
                        //     this.limitData=[];
                        // }
                        // console.log(this.limitData);
                        // this.limitPop=true;
                    }
                })

            },
            submitLimit(){
                let arr=this.$refs.upTree.getCheckedNodes();
                console.log(arr);
                let ids=[],ads=[];
                arr.map(val=>{
                    if(val.fid!=0){
                        ids.push(val.id);
                    }else{
                        ads.push(val.id)
                    }
                })
                this.form.role_adm_access_ids=ids.join(',');
                this.form.role_adm_id=ads.join(',');
                console.log(this.form);
                editBusiness(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.limitPop=false;
                        this.limitData=[];
                        this.form={
                            username: '',
                            password: '',
                            realname: '',
                            mobile: '',
                            role_id: '',
                            city:'',
                            city_id:'',
                            checkList:[],
                            proxy_type_ids:'',
                        }
                        this.getAllianceList();
                        this.getQxlist();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            cancelLimit(){
                this.getQxlist();
                this.limitPop=false;
                this.limitData=[];
                this.Limitform={
                    username: '',
                    password: '',
                    realname: '',
                    mobile: '',
                    role_id: '',
                    city:'',
                    city_id:'',
                    checkList:[],
                    proxy_type_ids:'',
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .top-box {
        width: 100%;
        height: 100px;
        background-color: #ffffff;
        padding: 20px;

        .tab-list {
            margin-top: 20px;

            h2 {
                margin-right: 20px;
                padding-right: 20px;
                border-right: 1px solid #eaeaea;
            }

            .item {
                font-size: 16px;
                color: #409EFF;
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon {
                    font-size: 20px;
                    color: #409EFF;
                    margin-right: 5px;
                }
            }
        }

    }

    .page-content {
        padding: 20px;

        .table {
            text-align: left;
            width: 100%;
            background-color: #fff;
            padding: 30px;
            box-shadow: 0 4px 4px 0 #e1e5eb;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
        }
    }
</style>
